import type * as Sentry from '@sentry/browser'
import { FlowContext } from '@wix/funnel-builder-lizard'

export const enrichSentry = (flowContext?: FlowContext) => {
  const { answers, metadata, experiments } = flowContext ?? {}

  const applyContext = (scope: Sentry.Scope) => {
    hasKeys(answers) && scope.setContext('answers', mapAnswers(answers))
    hasKeys(metadata) && scope.setContext('metadata', metadata)
    hasKeys(experiments) && scope.setContext('experiments', experiments)
  }

  window.Sentry?.configureScope(applyContext)
}

function hasKeys<T extends object>(obj: T | null | undefined): obj is T {
  return !!(obj && Object.keys(obj).length)
}

function mapAnswers(answers: FlowContext['answers']) {
  const res = new Map<string, string | string[]>()
  for (const key in answers) {
    const { values, skipped } = answers[key]
    res.set(key, values ? values : skipped ? 'skipped' : 'unknown')
  }
  return Object.fromEntries(res.entries())
}
